import React from "react";
import { Link } from "react-router-dom";

const PrimaryLinkButton = ({ to, children, className }) => {
const baseClassName =
  "mm-btnPrimary ring-2 ring-transparent focus:ring-mmFocus";
  const resolvedClassName = className
    ? `${baseClassName} ${className}`
    : baseClassName;

  return (
    <Link to={to} className={resolvedClassName}>
      {children}
    </Link>
  );
};

export default PrimaryLinkButton;
